import { useEffect } from "react";

/** Esc 키 누르면 handler 실행. 팝업 닫기 a11y용 공용 훅. */
export function useEscClose(handler: () => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") handler();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handler]);
}
